import { useMutation, UseMutationOptions } from '@tanstack/react-query'

import { API_ENDPOINTS } from '../../../common/apiEndpoints'
import {
  ErrorResponse,
  FileCompleteInput,
  FileCompleteResponse,
  fileCompleteResponseSchema,
} from '../../../common/validations'

import { post } from 'api/apiClient'

export const useAPIPostFileComplete = (
  options?: UseMutationOptions<
    FileCompleteResponse,
    ErrorResponse,
    FileCompleteInput
  >
) =>
  useMutation({
    mutationFn: (data) =>
      post(API_ENDPOINTS.FILE_COMPLETE, data, fileCompleteResponseSchema),
    ...options,
  })
